import utils from '@/utils/common';

export default class Ban {
  constructor(banTimeLeft, callback, template) {
    this.banTimeLeft = banTimeLeft;
    this.callback = callback;
    this.template = template;
  }

  run() {
    this.clearBanInterval();
    this.callback(this.generateErrorText());

    const intervalCallback = () => {
      this.clearBanInterval();
      this.callback(this.generateErrorText());
      this.banTimeLeft -= 1;
    };

    this.banTimeInterval = setInterval(intervalCallback, 1000);
  }

  stop() {
    this.banTimeLeft = 0;
    this.clearBanInterval();
    this.callback('');
  }

  clearBanInterval() {
    if (this.banTimeInterval && this.banTimeLeft <= 0) {
      clearInterval(this.banTimeInterval);
    }
  }

  generateErrorText() {
    let minutes = parseInt(this.banTimeLeft / 60, 10);
    let seconds = this.banTimeLeft % 60;

    minutes = utils.pluralWord(minutes, 'минуту', 'минуты', 'минут');
    seconds = utils.pluralWord(seconds, 'секунду', 'секунды', 'секунд');

    return this.template.replace('#TIME#', `${minutes} ${seconds}`);
  }
}
